import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import api from "../core/api"
import { isAtrasado } from "../core/utils"

import Back from "../components/Back"

class Boletos extends React.Component {
    state = {
        carregando: false,
        contratos: []
    }

    componentDidMount() {
        this.getBoletos()
    }

    getBoletos() {
        console.log("indo...")
        api.get("/contratos/boletos")
            .then(response => {
                console.log(response.data)
                this.setState({ carregando: false, contratos: response.data.contratos })
            })
            .catch(err => {})
    }

    render() {
        return (
            <section className="section">
                <div className="container content">
                    <div className="card">
                        <header className="card-header content-header">
                            <Back />
                            <h3 className="title is-5 nomargin">Lista de boletos Pendentes</h3>
                        </header>
                        <div className="card-content">
                            {this.state.carregando ? (
                                <div className="card-content">Aguarde...</div>
                            ) : (
                                this.state.contratos.map(contrato => {
                                    let keyContrato = parseInt(contrato.codigo).toString()

                                    return (
                                        <div
                                            className="card-info"
                                            key={keyContrato}
                                            style={{ marginTop: 10 }}
                                        >
                                            <div
                                                style={{
                                                    marginBottom: 10,
                                                    padding: 10,
                                                    backgroundColor: "#f4f4f4",
                                                    border: "solid 1px #ccc"
                                                }}
                                            >
                                                <strong>Contrato:</strong> {contrato.codigo}
                                                <br />
                                                <strong>Imovel:</strong> {contrato.imovel}
                                            </div>
                                            <table className="table card-info" style={{}}>
                                                <thead>
                                                    <tr>
                                                        <th>Recibo</th>
                                                        <th>Vencimento Original</th>
                                                        <th>Vencimento</th>
                                                        <th>Valor</th>
                                                        <th>Link</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {contrato.boletos.map(boleto => {
                                                        let clsBoleto = isAtrasado(
                                                            boleto.vencimento_original
                                                        )
                                                            ? "button is-danger is-small"
                                                            : "button is-link is-small"
                                                        return (
                                                            <tr
                                                                key={boleto.numero.toString()}
                                                                keys={boleto.numero.toString()}
                                                            >
                                                                <td>{boleto.numero}</td>
                                                                <td>
                                                                    {boleto.vencimento_original}
                                                                </td>
                                                                <td>{boleto.vencimento}</td>
                                                                <td>{boleto.valor}</td>
                                                                <td>
                                                                    {/* prettier-ignore */}
                                                                    <a rel="noopener noreferrer" href={boleto.link} target="_blank" className={clsBoleto} >
                                                                            Ver Boleto
                                                                        </a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                })
                            )}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => ({
    contrato: state.contrato
})

export default withRouter(connect(mapStateToProps)(Boletos))
